a.issue.edit = (function(){
	var my = {
		popup:function(o){
			var s = o || {};
			var isid = o.isid || undefined;
			var f_close = o.close || function(){};
			var f_save = o.save || function(){};
			// Open popup
			var token = a.popup.create({
				slideFrom:'fromleft',
				title:'Edit issue',
				css_class:'',
				winbar_action_icon:'trash',
				winbar_action:function(){
					if (confirm('This will delete the issue and all its history and content. Proceed?')) {
						$.ajax({
							type:'POST',
							url:'/api/issue/delete/',
							data:{
								isid:isid,
								token:localStorage.getItem('token'),
								accountname:localStorage.getItem('accountname')
							},
							dataType:'json',
							cache: false,
							success:function(result) {
								if (result.success) {
									window.history.back();
									a.s.growl.create('Success','The issue was deleted',{});
								}
								else {
									a.s.growl.create('Error','Unable to delete the issue',{});
								}
							}
						}).done(function(){
							
						});
					}
				},
				ready:function(token){
					my.loadContent(token,o);
				}
			});
		},
		loadContent:function(token,o){
			var s = o || {};
			var isid = o.isid || undefined;
			var f_close = o.close || function(){};
			var f_save = o.save || function(){};
			$.ajax({
				type:'GET',
				url:'/api/issue/load/',
				data:{
					isid:isid,
					token:localStorage.getItem('token'),
					accountname:localStorage.getItem('accountname')
				},
				dataType:'json',
				cache: false,
				success:function(result) {
					if (result.success) {
						var area = $('#popupid_'+token);
						// Display content
						tpl.run({tpl:'/tpl/issue/edit/popup.ejs?v='+v,data:result.data,cb:function(c){
							$('#popupid_'+token+'>.ic').empty().append(c).ready(function(){
								my.init({
									isid:isid,
									form:$('form[name="edit_issue"]',area),
									f_close:f_close,
									token:token,
									result:result
								});
							});
						}});
					}
					else {
						a.s.growl.create('Error','Issue not found',{});
					}
				}
			}).done(function(){});
		},
		init:function(o){
			var isid = o.isid || undefined;
			var form = o.form || undefined;
			var token = o.token || undefined;
			var f_close = o.f_close || function(reopen_display){};
			var result = o.result;
			var win = $('#popupid_'+o.token);
			// Granular gating: an 'own'-scoped user who didn't create this issue can't
			// edit or delete it (the API enforces the same) — hide the affordances.
			if (!a.s.ac.can('actions','issue',{made_by:(result.data.user_made_by||{}).uid})) {
				$('.popupwinbar>.action>i',win).hide();
				$('button[data-action="complete"]',win).hide();
			}
			// On name change, validate form
			$('input[name="name"]',form).change(function(){
				my.validateForm(token,form);
			});
			// Insert items picker element
			var ipe = a.s.itempickerelement();
			ipe.el = $('div[data-area="itemlistpicker"]',form);
			ipe.iid_list = result.data.itemlist.map(function(e){ return e.iid; });
			ipe.select_kit_as_whole = false;
			ipe.show_complete_kits = false;
			ipe.filter = {};
			ipe.change = function(){
				my.validateForm(token,form);
			}
			ipe.insert();
			// Insert date time picker
			a.s.datetimepicker.insert({
				el: $('div[data-area="deadline"]',form),
				inputname: 'deadline',
				timeformat: a.userinfo.timeformat,
				datetime: result.data.deadline,
				change:function(){
					a.issue.calcDuration(form,'The deadline must be at least 5 minutes into the future');
				},
				ready:function(){
					a.issue.calcDuration(form,'The deadline must be at least 5 minutes into the future');
				}
			});
			// Insert obo picker element
			a.s.pickerelement.insert({
				el: $('div[data-area="pprpicker"]',form),
				type: 'user',
				inputname: 'ppr',
				undefined_text: 'Select user',
				value:result.data.user_ppr.fullname,
				id:result.data.user_ppr.uid
			});
			// Insert location picker element
			a.s.pickerelement.insert({
				el: $('div[data-area="locationpicker"]',form),
				type: 'location',
				inputname: 'location',
				value:result.data.location.name,
				id:result.data.location.id
			});
			// Insert user picker element
			a.s.userpickerelement.insert({
				el: $('div[data-area="userlistpicker"]',form),
				uid_list:result.data.participantlist.map(function(e){ return e.uid; }),
				filter:{},
				change: function(){}
			});
			// Initial validation
			setTimeout(function(){
				my.validateForm(token,form);
			},500);
			// Save
			$('button[data-action="complete"]').unbind('click').click(function(){
				var data = form.serializeJSON();
				data.token = localStorage.getItem('token');
				data.accountname = localStorage.getItem('accountname');
				a.loader.fs.create();
				$.ajax({
					type:'POST',
					url:'/api/issue/save/',
					data:data,
					dataType:'json',
					cache: false,
					success:function(result) {
						if (result.success) {
							window.history.back();
							a.s.growl.create('Success','Issue changes was saved',{});
							setTimeout(function(){
								f_close(true);
							},400);
						}
						else {
							a.s.growl.create('Error','Unable to save the issue',{});
						}
					}
				}).done(function(){
					a.loader.fs.remove();
				});
			});
		},
		validateForm:function(token,form){
			var win = $('#popupid_'+token);
			var val = true;
			if ($('input[name="name"]',form).val().length<3) {
				val = false;
			}
			if ($('input[name="deadline"]',form).val().length==0) {
				val = false;
			}
			if (val) {
				$('button[data-action="complete"]',win).prop('disabled',false);
			}
			else {
				$('button[data-action="complete"]',win).prop('disabled',true);
			}
		}
	}
	return my;
}());